import { render, staticRenderFns } from "./AdminQuestionManagement.vue?vue&type=template&id=2e2b807f&scoped=true&"
import script from "./AdminQuestionManagement.vue?vue&type=script&lang=js&"
export * from "./AdminQuestionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b807f",
  null
  
)

export default component.exports